import React from 'react';
import { useDocumentationPagesPlugin } from '../../toolympus/components/Documentation';
import { useDocumentationPages } from '../../toolympus/components/Documentation/DocumentationPagesContext';
import { PowerEditorBaseProps, PowerEditorBase } from '../../toolympus/components/PowerDoc';
import { ColumnsPlugin } from '../../toolympus/components/PowerDoc/plugins/Columns';
import { ConfigurableTableBlockPlugin } from '../../toolympus/components/PowerDoc/plugins/ConfigurableTableBlock';
import { CustomFieldsBlockPlugin } from '../../toolympus/components/PowerDoc/plugins/CustomFieldsBlock';
import { ExpanderPlugin } from '../../toolympus/components/PowerDoc/plugins/Expander';
import { useMediaFilesPlugin } from '../../toolympus/components/PowerDoc/plugins/MediaFiles';
import { SettingsBlockPlugin } from '../../toolympus/components/PowerDoc/plugins/SettingsBlock';
import { TablesPlugin } from '../../toolympus/components/PowerDoc/plugins/Tables';
import { PowerEditorSettingsProvider } from '../../toolympus/components/PowerDoc/PowerEditorSettingsContext';
import { TilesCustomPlugin } from './TilesCustom';

const ProjectDocumentationEditorUnwrapped = (props: PowerEditorBaseProps) => {
    const { config } = useDocumentationPages();
    const mediaFilesPlugin = useMediaFilesPlugin();
    const pagesPlugin = useDocumentationPagesPlugin();

    const plugins = [
      TilesCustomPlugin,
      ColumnsPlugin,
      TablesPlugin,
      ExpanderPlugin,
      mediaFilesPlugin,
      pagesPlugin,
      SettingsBlockPlugin,
    ];

    if(config.enableCustomFieldsBlock) {
      plugins.push(
        CustomFieldsBlockPlugin, 
        ConfigurableTableBlockPlugin
      );
    }

    return (
        <PowerEditorBase
            {...props}
            plugins={plugins}
            autoFocus={!props.viewMode}
            />
    );
}


export const ProjectDocumentationEditor = (props: PowerEditorBaseProps) => {
    return (
        <PowerEditorSettingsProvider EditorComponent={ProjectDocumentationEditorUnwrapped}>
            <ProjectDocumentationEditorUnwrapped {...props} />
        </PowerEditorSettingsProvider>
    );
}
